import axios from '@plugins/axios'
import config from '@src/app.config'
const env = config.env
const appConfig = config[env]

// const serverUrl = appConfig.server_url

export const state = {
  aAndBData: [
    {
      domainId: 1,
      dimension: 'Síntomas fisiológicos',
      withoutRisk: {
        number: 7,
        percentage: 11.7,
      },
      lowRisk: {
        number: 8,
        percentage: 13.3,
      },
      middleRisk: {
        number: 14,
        percentage: 23.3,
      },
      highRisk: {
        number: 17,
        percentage: 28.3,
      },
      veryHighRisk: {
        number: 14,
        percentage: 23.3,
      },
    },
    {
      domainId: 1,
      dimension: 'Síntomas de comportamiento social',
      withoutRisk: {
        number: 7,
        percentage: 11.7,
      },
      lowRisk: {
        number: 8,
        percentage: 13.3,
      },
      middleRisk: {
        number: 14,
        percentage: 23.3,
      },
      highRisk: {
        number: 17,
        percentage: 28.3,
      },
      veryHighRisk: {
        number: 14,
        percentage: 23.3,
      },
    },
    {
      domainId: 1,
      dimension: 'Síntomas intelectuales y laborales',
      withoutRisk: {
        number: 7,
        percentage: 11.7,
      },
      lowRisk: {
        number: 8,
        percentage: 13.3,
      },
      middleRisk: {
        number: 14,
        percentage: 23.3,
      },
      highRisk: {
        number: 17,
        percentage: 28.3,
      },
      veryHighRisk: {
        number: 14,
        percentage: 23.3,
      },
    },
    {
      domainId: 1,
      dimension: 'Síntomas psicoemocionales',
      withoutRisk: {
        number: 7,
        percentage: 11.7,
      },
      lowRisk: {
        number: 8,
        percentage: 13.3,
      },
      middleRisk: {
        number: 14,
        percentage: 23.3,
      },
      highRisk: {
        number: 17,
        percentage: 28.3,
      },
      veryHighRisk: {
        number: 14,
        percentage: 23.3,
      },
    },
    {
      general: 'Factores de Riesgo Psicosocial estrés',
      isTotalGeneral: true,
      withoutRisk: {
        number: 5,
        percentage: 8.3,
      },
      lowRisk: {
        number: 9,
        percentage: 15,
      },
      middleRisk: {
        number: 10,
        percentage: 16.7,
      },
      highRisk: {
        number: 13,
        percentage: 21.7,
      },
      veryHighRisk: {
        number: 23,
        percentage: 38.3,
      },
    },
  ],
}

export const mutations = {
}

export const getters = {
  aAndBData: (state) => state.aAndBData
}

export const actions = {}